import { axios } from '@/services/axios';

const portedOutPlatformNumber = async (numberId, platformId, scope) => {
    const res = await axios.post(
        `/PlatformNumber/${numberId}/Platform/${platformId}/PortedOut`,
        null,
        {
            headers: {
                'X-RequestScope': scope,
            },
        },
    );
    return res.data;
};
export default portedOutPlatformNumber;
